import classNames from 'classnames';

interface DividerProps {
  className?: string;
}

export const Divider = ({ className }: DividerProps) => (
  <hr className={classNames('h-px border-dark-quaternary', className)} />
);
